import * as React from 'react';

export const ExpressQuoteIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='51'
    height='46'
    viewBox='0 0 241 215'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M49.0242 42.25C58.1607 34.1219 68.8956 27.9906 80.5411 24.25M32.1401 152.5C38.0304 162.083 45.6665 170.479 54.6522 177.25M107.556 87.25L122.188 92.875L127.816 107.5L122.188 122.125L107.556 127.75M107.556 87.25L92.9227 92.875L87.2947 107.5L92.9227 122.125L107.556 127.75M107.556 87.25V53.5M107.556 127.75V161.5M124.44 97.375L154.831 80.5M124.44 117.625L154.831 134.5M90.6715 117.625L60.2802 134.5M90.6715 97.375L60.2802 80.5M97.4251 19.75C97.4251 20.3713 96.9212 20.875 96.2995 20.875C95.6779 20.875 95.1739 20.3713 95.1739 19.75C95.1739 19.1287 95.6779 18.625 96.2995 18.625C96.9212 18.625 97.4251 19.1287 97.4251 19.75ZM163.836 107.5C163.836 138.566 138.638 163.75 107.556 163.75C76.4729 163.75 51.2754 138.566 51.2754 107.5C51.2754 76.434 76.4729 51.25 107.556 51.25C138.638 51.25 163.836 76.434 163.836 107.5ZM112.058 107.5C112.058 109.985 110.042 112 107.556 112C105.069 112 103.053 109.985 103.053 107.5C103.053 105.015 105.069 103 107.556 103C110.042 103 112.058 105.015 112.058 107.5Z'
      strokeWidth='8'
      strokeLinecap='round'
      strokeLinejoin='round'
      stroke='black'
    />
    <path
      d='M207.734 82.75L167.213 145.75H198.729L180.72 211L237 132.25H203.232L223.493 82.75H207.734Z'
      fill='black'
      strokeWidth='8'
      strokeLinecap='round'
      strokeLinejoin='round'
      stroke='black'
    />
    <path
      d='M155.984 198.992C147.143 203.68 137.544 207.126 127.419 209.094'
      strokeWidth='8'
      strokeLinecap='round'
      strokeLinejoin='round'
      stroke='black'
    />
    <path
      d='M202.579 66.3239C186.638 29.6635 150.072 4 107.556 4C50.4019 4 4 50.377 4 107.5C4 164.623 50.4019 211 107.556 211C114.349 211 120.99 210.345 127.419 209.094'
      strokeWidth='8'
      strokeLinecap='round'
      strokeLinejoin='round'
      stroke='black'
    />
  </svg>
);
